import script from "./yx.vue?vue&type=script&setup=true&lang=js"
export * from "./yx.vue?vue&type=script&setup=true&lang=js"

import "./yx.vue?vue&type=style&index=0&id=5eac1ffe&scoped=true&lang=scss"

import exportComponent from "D:\\D盘\\桌面\\项目\\王者荣耀后台管理系统\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eac1ffe"]])

export default __exports__